export default {
  'Add Cut': '添加片段',
}